
import { useLocation, useNavigate } from 'react-router-dom';
import { useState, useCallback, useEffect, } from 'react';
// @mui
import {
    Card,
    Table,
    Paper,
    TableRow,
    TableBody,
    TableCell,
    Typography,
    TableContainer,
    CircularProgress,
    Box,
    Grid,
    Pagination,

} from '@mui/material';
// components


import { UserListHead } from '../sections/@dashboard/user';


// hooks
import { useAxios } from '../context/AxiosHookContext';

// ----------------------------------------------------------------------

const TABLE_HEAD_TYPES = [
    { id: '', label: 'Universidad', alignRight: false},
    { id: '', label: 'Total', alignRight: true }
];
const TABLE_HEAD_TYPES2 = [
    { id: '', label: 'Carrera Universitaria', alignRight: false },
    { id: '', label: 'Total', alignRight: true }
];

// ----------------------------------------------------------------------

const ReportTicketsPageBase = () => {

    const { state } = useLocation();
    const navigate = useNavigate();
    const axios = useAxios();
    const [report,setReport] = useState({});
    const [loading, setLoading] = useState(false);

    if (!state) {
        navigate("/enrollment")
    }

    const getEnrollmentReport = useCallback(async () => {
        try {

            setLoading(true);
            const { data } = await axios.get(`/enrollment/report_participant_totals/${state._id}`)

            const result = data.data[0]
                
            const report = {
                masculinos: (result?.sexo?.find(item => item.description === "Masculino"))?.count || 0,
                femeninos: (result?.sexo?.find(item => item.description === "Femenino"))?.count || 0,
                universidades: result?.universities || [],
                carreras: result?.subjects || [],
                total: (result?.total[0]?.count || 0) || 0,
                egresados: (result?.egresados[0]?.count || 0) || 0,
                estudiantes: (result?.estudiantes[0]?.count || 0) || 0
                
            }
            setReport(report)

        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }, [axios,setReport,setLoading]);


    useEffect(() => {
        getEnrollmentReport();
    }, [getEnrollmentReport])

    return (
        <>

            <Card sx={{
                border: "1px solid #dfd2d2",
                borderRadius: 4,
                m: 2
            }}>

                <Grid container alignItems={"center"} spacing={2} sx={{width:"100%", justifyContent: {lg: "space-between", xs: "flex-start"}}}>
                    <Grid item xs={12} sm={4} md={3} lg={2} >
                        <Box width={"100%"} textAlign={"center"} p={1} sx={{
                            border: "1px solid #d4d1f1",
                            borderRadius: 4,
                            m: 1
                        }}>

                            <Typography variant="h4" gutterBottom>
                                Femeninos
                            </Typography>

                            <Typography variant="h6" gutterBottom>
                                {
                                    loading ? (
                                        <CircularProgress size={'15px'} />
                                    ) : (
                                        report.femeninos
                                    )
                                }
                            </Typography>

                        </Box>
                    </Grid>

                    <Grid item xs={12} sm={4} md={3} lg={2} >
                        <Box width={"100%"} textAlign={"center"} p={1} sx={{
                            border: "1px solid #d4d1f1",
                            borderRadius: 4,
                            m: 1
                        }}>

                            <Typography variant="h4" gutterBottom>
                                Masculinos
                            </Typography>

                            <Typography variant="h6" gutterBottom>
                                {
                                    loading ? (
                                        <CircularProgress size={'15px'} />
                                    ) : (
                                        report.masculinos
                                    )
                                }
                            </Typography>


                        </Box>
                    </Grid>

                    <Grid item xs={12} sm={4} md={3} lg={2} >
                        <Box width={"100%"} textAlign={"center"} p={1} sx={{
                            border: "1px solid #d4d1f1",
                            borderRadius: 4,
                            m: 1
                        }}>

                            <Typography variant="h4" gutterBottom>
                                Profesionales
                            </Typography>

                            <Typography variant="h6" gutterBottom>
                                {
                                    loading ? (
                                        <CircularProgress size={'15px'} />
                                    ) : (
                                        report.egresados
                                    )
                                }
                            </Typography>

                        </Box>
                    </Grid>

                    <Grid item xs={12} sm={4} md={3} lg={2} >
                        <Box width={"100%"} textAlign={"center"} p={1} sx={{
                            border: "1px solid #d4d1f1",
                            borderRadius: 4,
                            m: 1
                        }}>

                            <Typography variant="h4" gutterBottom>
                                Estudiantes
                            </Typography>

                            <Typography variant="h6" gutterBottom>
                                {
                                    loading ? (
                                        <CircularProgress size={'15px'} />
                                    ) : (
                                        report.estudiantes
                                    )
                                }
                            </Typography>

                        </Box>
                    </Grid>

                    <Grid item xs={12} sm={4} md={3} lg={2} >
                        <Box width={"100%"} textAlign={"center"} p={1} sx={{
                            border: "1px solid #d4d1f1",
                            borderRadius: 4,
                            m: 1
                        }}>

                            <Typography variant="h4" gutterBottom>
                                Total
                            </Typography>

                            <Typography variant="h6" gutterBottom>
                                {
                                    loading ? (
                                        <CircularProgress size={'15px'} />
                                    ) : (
                                        report.total
                                    )
                                }
                            </Typography>

                        </Box>
                    </Grid>
                </Grid>
            </Card>

            <Card sx={{
                border: "1px solid #dfd2d2",
                borderRadius: 4,
                m: 1,
                marginTop: 5,
            }}>
                <TableContainer>

                    <Table>
                        <UserListHead
                            headLabel={TABLE_HEAD_TYPES}
                        />
                        <TableBody>
                            {report.universidades?.map((row) =>

                            (
                                <TableRow hover key={row._id} tabIndex={-1} role="checkbox" sx={{ cursor: "pointer" }} >

                                    <TableCell align="left">
                                        {
                                            row.description
                                        }
                                    </TableCell>

                                   
                                    <TableCell align="right" sx={{ fontWeight: "bold" }}>
                                    {row.count}
                                    </TableCell>

                                </TableRow>
                            ))}
                        </TableBody>

                        {
                            loading === true &&
                            <TableBody>
                                <TableRow>
                                    <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                                        <Paper
                                            sx={{
                                                textAlign: 'center',
                                            }}
                                        >

                                            <CircularProgress size={"30px"} sx={{ color: "#aa9e97", marginRight: "auto", marginLeft: "auto" }} />

                                        </Paper>
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        }

                        {
                            (false) &&
                            <TableBody>
                                <TableRow>
                                    <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                                        <Paper
                                            sx={{
                                                textAlign: 'center',
                                            }}
                                        >

                                            <Typography variant="h6" paragraph>
                                                Sin resultados
                                            </Typography>

                                            <Typography variant="body2">
                                                No se encontraron resultados
                                            </Typography>
                                        </Paper>

                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        }
                    </Table>
                </TableContainer>

                

            </Card>

            <Card sx={{
                border: "1px solid #dfd2d2",
                borderRadius: 4,
                m: 1,
                marginTop: 5,
            }}>
                <TableContainer >

                    <Table>
                        <UserListHead
                            headLabel={TABLE_HEAD_TYPES2}
                        />
                        <TableBody>
                            {report.carreras?.map((row) =>

                            (
                                <TableRow hover key={row._id} tabIndex={-1} role="checkbox" sx={{ cursor: "pointer" }} >

                                    <TableCell align="left">
                                        {
                                            row.description
                                        }
                                    </TableCell>

                                   
                                    <TableCell align="right" sx={{ fontWeight: "bold" }}>
                                    {row.count}
                                    </TableCell>

                                </TableRow>
                            ))}
                        </TableBody>

                        {
                            loading === true &&
                            <TableBody>
                                <TableRow>
                                    <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                                        <Paper
                                            sx={{
                                                textAlign: 'center',
                                            }}
                                        >

                                            <CircularProgress size={"30px"} sx={{ color: "#aa9e97", marginRight: "auto", marginLeft: "auto" }} />

                                        </Paper>
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        }

                        {
                            (false) &&
                            <TableBody>
                                <TableRow>
                                    <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                                        <Paper
                                            sx={{
                                                textAlign: 'center',
                                            }}
                                        >

                                            <Typography variant="h6" paragraph>
                                                Sin resultados
                                            </Typography>

                                            <Typography variant="body2">
                                                No se encontraron resultados
                                            </Typography>
                                        </Paper>

                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        }
                    </Table>
                </TableContainer>

                

            </Card>

        </>
    );
}

export default function ReportTicketsPage() {
    return (

        <ReportTicketsPageBase />
    )
}